import React from 'react';
import { BookOpen, Target, Users, Trophy } from 'lucide-react';

const categories = [
  {
    title: "Professional Team Names",
    examples: ["City Titans", "Metro Knights", "Global Elite"],
    description: "Professional names often incorporate city names and convey strength, excellence, and prestige."
  },
  {
    title: "Streetball Team Names",
    examples: ["Court Kings", "Concrete Legends", "Hood Dynasty"],
    description: "Streetball names typically reflect urban culture, attitude, and street credibility."
  },
  {
    title: "College Team Names",
    examples: ["State Warriors", "University Thunder", "Campus Knights"],
    description: "College team names often include academic references and traditional sporting elements."
  }
];

const tips = [
  {
    icon: BookOpen,
    title: "Research Your Competition",
    content: "Look at existing team names in your league or area to ensure uniqueness."
  },
  {
    icon: Target,
    title: "Consider Your Audience",
    content: "Choose a name that resonates with your fans and community."
  },
  {
    icon: Users,
    title: "Team Identity",
    content: "Reflect your team's playing style and values in your name."
  },
  {
    icon: Trophy,
    title: "Future Growth",
    content: "Select a name that can grow with your team's aspirations."
  }
];

export default function BasketballGuide() {
  return (
    <section className="py-20 bg-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Complete Guide to Basketball Team Names
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {categories.map((category, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{category.title}</h3>
              <ul className="space-y-2 mb-4">
                {category.examples.map((example, i) => (
                  <li key={i} className="text-orange-600">{example}</li>
                ))}
              </ul>
              <p className="text-gray-600">{category.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-lg shadow-md">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Tips for Choosing Your Basketball Team Name
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {tips.map((tip, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-orange-100 mb-4">
                  <tip.icon className="w-6 h-6 text-orange-600" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{tip.title}</h4>
                <p className="text-gray-600">{tip.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}